import { JobPostingDetail } from '../types';
import { cleanQuillHtmlContent } from '../utils';

export const isJobPostingDescriptionLengthValid = (description?: string) => {
  const cleanDescription = cleanQuillHtmlContent(description);

  if (!cleanDescription || cleanDescription.length < 100) {
    return false;
  }

  return true;
};

export function handleJobPostingDescriptionLengthValidator(
  _: unknown,
  description?: JobPostingDetail['description']
): Promise<boolean> {
  if (!isJobPostingDescriptionLengthValid(description)) {
    // TODO: TRADUZIR ISSO AQ NO FINAL
    return Promise.reject(new Error('A descrição da vaga deve possuir ao menos 100 caracteres'));
  }

  return Promise.resolve(true);
}
